
export const aesKey = "DGUE529uJc8OJpI6"; // Get AES key from environment variables